/**
 * Extracts and sanitizes the filename from a `Content-Disposition` header value. Returns null when the
 * header is absent or carries no filename, leaving the fallback name to the caller. Keeps only the final
 * path segment and strips control characters so a crafted header value can only ever name the download.
 */
export function extractContentDispositionFilename(header: string | null): string | null {
  if (!header) {
    return null;
  }

  const matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(header);
  if (!matches || !matches[1]) {
    return null;
  }

  const candidate = matches[1].replace(/['"]/g, '');
  const printable = Array.from(candidate)
    .filter((ch) => {
      const code = ch.charCodeAt(0);
      return code >= 32 && code !== 127;
    })
    .join('');
  const basename = printable.split(/[\\/]/).pop()?.trim();
  return basename ? basename : null;
}
